import {
  Flex,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text
} from "@chakra-ui/react";

import { BsThreeDots } from "react-icons/bs";
import { FaRegTrashAlt } from "react-icons/fa";
import { MdOutlineEmail, MdOutlineModeEdit } from "react-icons/md";

import { TeamMember } from "@/jenesys-types/jenesys-entities/config";

import Barrier from "@/components/common/permission/Barrier";

interface MemberActionsMenuProps {
  member: TeamMember;
  onMemberMenuClick: (member: TeamMember) => void;
  openMemberDetails: (member: TeamMember) => void;
  handleInviteResend: () => void;
  triggerDeleteWarning: (member: TeamMember) => void;
}

export const MemberActionsMenu: React.FC<MemberActionsMenuProps> = ({
  member,
  onMemberMenuClick,
  openMemberDetails,
  handleInviteResend,
  triggerDeleteWarning
}) => (
  <Menu>
    <MenuButton
      as={IconButton}
      icon={<BsThreeDots />}
      variant="ghost"
      aria-label="Actions"
      onClick={() => onMemberMenuClick(member)}
      _hover={{ bg: "#DF37631A" }}
    />
    <MenuList minW="200px" borderRadius="md" boxShadow="lg">
      <Barrier show when="company.members.update">
        <MenuItem
          onClick={() => openMemberDetails(member)}
          _hover={{ bg: "#DF37631A" }}
          bg="transparent"
        >
          <Flex align="center" gap={3}>
            <MdOutlineModeEdit size={18} />
            <Text fontSize="14px" fontWeight="500" color="black">
              Edit details
            </Text>
          </Flex>
        </MenuItem>
      </Barrier>

      {!member.user.is_email_confirmed && (
        <Barrier show when="company.members.update">
          <MenuItem
            onClick={() => handleInviteResend()}
            bg="transparent"
            _hover={{ bg: "#DF37631A" }}
          >
            <Flex align="center" gap={3}>
              <MdOutlineEmail size={18} color="black" />
              <Text fontSize="14px" fontWeight="500" color="black">
                Resend Invitation
              </Text>
            </Flex>
          </MenuItem>
        </Barrier>
      )}

      <Barrier show when="company.members.delete">
        <MenuItem
          onClick={() => triggerDeleteWarning(member)}
          bg="transparent"
          _hover={{ bg: "#DF37631A" }}
        >
          <Flex align="center" gap={3}>
            <FaRegTrashAlt size={18} color="black" />
            <Text fontSize="14px" fontWeight="500" color="black.500">
              Delete user
            </Text>
          </Flex>
        </MenuItem>
      </Barrier>
    </MenuList>
  </Menu>
);
